import UserStore from '@/stores/UserStore';
import { getLuckyOrangeSessionId } from './luckyOrange';

export interface SupportContextPayload {
    url: string;
    userId: string;
    contactId: string;
    account: string;
    luckyOrangeSessionId: string;
}

export async function buildSupportContext(): Promise<SupportContextPayload> {
    const user = UserStore.user;
    const contact = user?.default_contact;
    const luckyOrangeSessionId = (await getLuckyOrangeSessionId()) ?? '';

    return {
        url: window.location.href,
        userId: user?.id != null ? String(user.id) : '',
        contactId: contact?.id != null ? String(contact.id) : '',
        account: contact?.account ?? '',
        luckyOrangeSessionId,
    };
}

export async function formatSupportContextText(): Promise<string> {
    const ctx = await buildSupportContext();

    return [
        '--- PartsBadger support context ---',
        `URL: ${ctx.url}`,
        `User ID: ${ctx.userId || 'n/a'}`,
        `Contact ID: ${ctx.contactId || 'n/a'}`,
        `Account: ${ctx.account || 'n/a'}`,
        `Lucky Orange session: ${ctx.luckyOrangeSessionId || 'n/a'}`,
        '---',
        '',
        'Describe the issue:',
    ].join('\n');
}
